export const environment = {
    
    env: "u.a.t",
    ingestionApi:{
        address: "https://uat-hfq-ingestion.chill.ie"
    },
    discount:{
        amount: 40
    },
    mercuryApi:{
        appId: 20,
        address: "https://uat-mercury.chill.ie",
        username: "hfq@chill.ie",
        password: "qYc_sL3iwtg6OUc7THI1"
    },
    eventStream:{
        journeyEventURL: "https://dev-api.chill.ie/hfq/dev/v1/api/eventstreaming/homequotejourney",
        subscriptionKey: "d975cd7db72f43a28dc399129be67dc6"
    },
     marketing:{
        chill:{
            consentNotes: "Never miss a great insurance deal with Chill! We'll keep you informed of all your insurance needs over the phone and via digital communications. Tick the box to opt in."
        },
        quoteDevil:{
            consentNotes: "Never miss a great insurance deal or promotion with Quote Devil! We'll keep you informed of all your Insurance needs throughout the year over the phone and via email, SMS and post. Tick the box to opt in."
        }
    },
    chill:{
        portalAddress: 'https://sandbox.chill.ie'
    },
    quoteDevil:{
        portalAddress: 'https://staging.quotedevil.ie'
    }
};
